
export default class Schema {
  values = {};
  dtoDefinition = {};
  policiesMap = {};
  policies = {};

  constructor(policies, values, dtoDefinition) {
    if (values) this.values = values;
    this.policies = policies;
    this.policiesMap = this.__createPoliciesMap();
    this.dtoDefinition = dtoDefinition;
  }

  setDtoDefinition(dtoDefinition) {
    this.dtoDefinition = dtoDefinition;
  }

  getValues() {
    return this.values;
  }

  __createPoliciesMap(policies) {
    let newPoliciesMap = {};
    for (var key in this.policies) newPoliciesMap[this.policies[key].id] = key;
    return newPoliciesMap;
  }

  __iterateArray(arrayObject, objectMapping) {
    const result = arrayObject.map((value) => {
      let objectToAdd = {};

      for (let keyValue in value) {
        const property = objectMapping[keyValue];

        if (this.policies.hasOwnProperty(property)) objectToAdd[property] = value[keyValue];
      }
      return objectToAdd;
    });

    return result;
  }

  __validJsonParse = (obj) => {
    try {
      let result = JSON.parse(obj);
      if (Array.isArray(result) && result.length && result[0]) return result;
      else return [];
    } catch (e) {
      return [];
    }
  }

  getValuesFormatted() {
    let values = this.values;
    let newValues = {};

    for (let key in values) {
      const property = this.policiesMap[key];

      if (this.policies.hasOwnProperty(property)) {

        if (this.policies[property]?.type === 'array' && !!values[key]) {
          const arrayObject = this.__validJsonParse(values[key]);

          if (Array.isArray(arrayObject)) {
            newValues[property] = this.__iterateArray(
              arrayObject,
              this.policiesMap
            );
          }
        } else newValues[property] = values[key];
      }
    }

    return newValues;
  }

  formatRequestValues(values=this.values, policies=this.policies, dtoDefinition=this.dtoDefinition) {
    // const { values=this.values, policies=this.policies, dtoDefinition=this.dtoDefinition } = arguments;

    const DTO = dtoDefinition;

    for (let propValue in values) {
      //get the id from value in policies for match in DTO, and type for validate the data type
      const { id, type, dontFormatResponse } = policies[propValue];

      //validate if the value to add in DTO exists
      if (!DTO.hasOwnProperty(id)) continue;
      if (dontFormatResponse) continue;
      //if the value is not a array, so add to DTO and continue;
      if (!Array.isArray(DTO[id])) {
        DTO[id] = (type === 'number') ? Number(values[propValue]) : values[propValue];
        continue;
      };

      //get the structure for any object in the array for validate any prop inside
      const dtoArrayObjectValidate = DTO[id][0];

      DTO[id] = values[propValue].map((value) => {
        if (typeof value !== 'object' || value === null) return value;

        if (Array.isArray(value)) {
          //console.log("its a array");
        }

        let objectToAdd = {};

        for (let keyValue in value) {
          const idValue = this.policies[keyValue].id;
          if (dtoArrayObjectValidate.hasOwnProperty(idValue)) {

            objectToAdd[idValue] = value[keyValue];
          }
        }
        return objectToAdd;
      });
    }

    return DTO;
  }

  //TODO: refactorizar de manera recursiva.
  setDefaultValues(values) {
    for (let key in values) {
      const id = this.policies[key].id;
      const type = this.policies[key].type;

      if (this.dtoDefinition.hasOwnProperty(id)) {
        if (Array.isArray(this.dtoDefinition[id])) {
          const arrayobject = this.dtoDefinition[id][0];

          this.values[id] = values[key].map((value) => {
            if (typeof value !== 'object') return value;

            let objectToAdd = {};
            for (let keyValue in value) {
              const idValue = this.policies[keyValue].id;
              if (arrayobject.hasOwnProperty(idValue)) {

                objectToAdd[idValue] = value[keyValue];
              }
            }
            return objectToAdd;
          });
        } else {
          const newValue = type === 'number' ? Number(values[key]) : values[key];
          this.values[id] = newValue;
        }
      }
    }
  }


}
